import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        active: String,
        first: String,
        second: String,
    };

    static targets = [
        'container',
    ];

    toggle(event) {
        event.preventDefault();

        if (!this.activeValue || this.activeValue === 'first') {
            this.containerTarget.innerHTML = this.secondValue;
            this.activeValue = 'second';
        } else {
            this.containerTarget.innerHTML = this.firstValue;
            this.activeValue = 'first';
        }
    }
}
